import { z } from "zod";

import { validationTotpErrorMessages } from "../i18n/validation-error-codes.ts";

export const totpCodeSchema = z
  .string()
  .regex(/^\d{6}$/, validationTotpErrorMessages.invalidFormat.id);
